import day_1 from '../assets/images/internship/day-1.jpg';
import day_2 from '../assets/images/internship/day-2.jpg';
import day_3 from '../assets/images/internship/day-3.jpg';

import day_4 from '../assets/images/internship/day-4.jpg';
import day_5 from '../assets/images/internship/day-5.jpg';
import day_6 from '../assets/images/internship/day-6.jpg';

import day_7 from '../assets/images/internship/day-7.jpg';
import day_8 from '../assets/images/internship/day-8.jpg';
import day_9 from '../assets/images/internship/day-9.jpg';

import flowair from '../assets/images/internship/video/Flowair.mp4';
import kan from '../assets/images/internship/video/Kan.mp4';
import ventair from '../assets/images/internship/video/Ventair.mp4';

export const internships = [ {
  title : '',
  desc  : 'Компания Everest Group в партнерстве с европейскими заводами по производству инженерного оборудования и материалов, организовали недельный тренинг для специалистов компании. Первым стал польский завод  Flowair по производству климатического оборудования: тепловых вентиляторов зима/лето, воздушных тепловых завес, дестрафикаторов.',
  images: [ {
      src: day_1
  }, {
      src: day_2
  } ],
  video: flowair
}, {
    title : '',
    desc  : 'Вторым в очереди, но не по значению стал завод KAN Therm (Польша), европейский производитель трубопроводов и комплектующих для систем тепло- холодоснабжения, теплых полов, водоснабжения, пожаротушения и т.д. Это была отличная возможность глубже погрузиться в производственные процессы, узнать о новых технологиях и получить ценные знания напрямую от производителя. Мы ценим такие встречи, ведь они помогают нам становиться еще сильнее как инжиниринговая компания — усиливая наши компетенции и расширяя возможности для клиентов. Благодарим KAN-therm за теплый прием, профессионализм и вдохновение!',
    images: [ {
        src: day_4
    }, {
        src: day_5
    }, {
        src: day_6
    } ],
    video: kan
}, {
    title : '',
    desc  : 'Третьим заводом стал чешский производитель вентиляционного оборудования VentiAir. Современный подход к производству, европейское качество, сертификаты соответствия мировым стандартам, индивидуальные решения к каждому заказу, это и многое другое отличает VentiAir. Мы провели продуктивные тренинги и получили возможность ближе познакомиться с производственными процессами. Благодарим команду Ventiair за теплый приём и полезный обмен опытом!',
    images: [ {
        src: day_7
    }, {
        src: day_8
    }, {
        src: day_9
    } ],
    video: ventair
} ];